module.exports = __webpack_public_path__ + "img/25.840ddcb7.jpg";